// @ts-strict-ignore
import { Box } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { Arrange, Pill, Toggle } from "@aviary";
import { FilterType } from "@shared/hooks/useAnalyticsLogger/useAnalyticsLogger";
import { useCatalogSearch } from "@shared/hooks/useCatalogSearch/useCatalogSearch";
import { l } from "@shared/locales/i18n";
import { useIsFullscriptJsVar } from "@shared/reactiveVar/useIsFullscriptJs/useIsFullscriptJs.store";
import { isInOfficeCheckoutVar } from "@shared/reactiveVar/useIsInOfficeCheckoutVar/useIsInOfficeCheckoutVar.store";

import * as styles from "./FullscriptTested.styles";

interface Props {
  logFilterEvent: (entityName: string, entityType: string) => void;
  isContextual?: boolean;
  contextualData?: number;
}

const FullscriptTested = ({ logFilterEvent, isContextual = false, contextualData = 0 }: Props) => {
  const { t } = useTranslation();
  const { isFsTested, setIsFsTested } = useCatalogSearch();
  const isFullscriptJs = useIsFullscriptJsVar();
  const isInOfficeCheckout = isInOfficeCheckoutVar();

  const hasNoContextualData = isContextual ? contextualData === 0 : false;
  if (isFullscriptJs || isInOfficeCheckout || hasNoContextualData) {
    return null;
  }

  const onChange = () => {
    if (!isFsTested) {
      logFilterEvent("true", FilterType.IS_FS_TESTED);
    }

    setIsFsTested(!isFsTested);
  };

  const renderLabel = () => {
    if (isContextual) {
      return `${t(l.sharedCatalog.filter.FSTested)} (${contextualData})`;
    }

    return t(l.sharedCatalog.filter.FSTested);
  };

  return (
    <Box backgroundColor="system" padding="xsmall" customCss={styles.container}>
      <Arrange alignment="center" spacing="xsmall">
        <Toggle
          onClick={onChange}
          isOn={isFsTested}
          onLabel={renderLabel()}
          offLabel={renderLabel()}
          css={styles.toggle}
        />
        <Pill size="xsmall" isLight>
          {t(l.sharedCatalog.filter.NewBadge)}
        </Pill>
      </Arrange>
    </Box>
  );
};

export { FullscriptTested };
